<template>
  <div>
    <transition name="slide-fade">
      <div class="storage" v-if="count">
        <modal name="storage"
            transition="nice-modal-fade"
            :min-width="200"
            :min-height="200"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            width="80%"
            height="auto"
        >
          <div class="in-modal">
            <div class="header">
              <h1>{{ $t('message.favourites') }}</h1>
            </div>
            <div class="content row">
              <div class="col-md-12 categories">
                <h5>{{ $t('message.categories') }}</h5>
                <ul>
                  <li v-for="item in items">{{item.name}} <span class="x" @click="delete_from_storage(item)">&times;</span></li>
                </ul>
              </div>
              <div class="col-md-12 buttons text-right">
                <button class="btn btn-default" @click="hide('storage')">{{ $t('message.close') }}</button>
              </div>
            </div>
          </div>
        </modal>
        <div class="row info" v-if="info_show">
          <div class="col-md-12">
            <div class="alert alert-primary" role="alert">
              {{ $t('message.favourites_text') }}
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 choose">
            <div class="row">
              <div class="col-md-5 col-sm-5 col-4 option option-all">
                <a @click="switchTo('all')" v-bind:class="{ active: !toggle_button_is_storage }" class="text">{{ $t('message.all_products') }}</a>
              </div>
              <div class="col-md-2 col-sm-2 col-4">
                <toggle-button v-model="toggle_button_is_storage"
                  :value="true"
                  :width=55
                  :height=30
                  :sync="true"
                  :color="{checked: '#23497f', unchecked: '#23497f', disabled: '#CCCCCC'}"
                  :disabled="!toggle_button_show"
                  @change="toggle_button_change()"
                  />
              </div>
              <div class="col-md-5 col-sm-5 col-4 option option-storage">
                <a @click="switchTo('storage')" v-bind:class="{ active: toggle_button_is_storage }" class="text"> {{ $t('message.favourites') }}</a> <a class="btn btn-primary btn-sm" @click="show('storage')">{{ $t('message.show_favourites_list') }} ({{count}})</a></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data () {
    return {
      msg: 'Storage',
      toggle_button_is_storage: false,
      toggle_button_show: true,
      first: true,
    }
  },
  methods: {
    show(name) {
      this.$modal.show(name);
    },
    hide(name) {
      this.$modal.hide(name);
    },
    delete_from_storage(category) {
      this.$store.dispatch('pricelist/delete_from_storage', category);
      if(this.count === 0) {
        this.$store.dispatch('pricelist/switch_to_all');
      }
    },
    set_first_to_false() {
      this.first = false;
    },
    toggle_button_change() {
      this.toggle_button_show = false;
      if(this.toggle_button_is_storage) {
        this.$store.dispatch('pricelist/switch_to_storage').then(() => {
          this.toggle_button_show = true;
        });
      }
      else {
        this.$store.dispatch('pricelist/switch_to_all').then(() => {
          this.toggle_button_show = true;
        });
      }
      window.scrollTo(0,0);
    },
    switchTo(destanation) {

      if('storage' === destanation && !this.is_storage) {
        this.toggle_button_is_storage = true;
        this.toggle_button_change();
      }

      if('all' === destanation && this.is_storage) {
        this.toggle_button_is_storage = false;
        this.toggle_button_change();
      }

    }
  },
  computed: {
    items() {
      return this.$store.getters['pricelist/storage'];
    },
    count() {
      return this.$store.getters['pricelist/storage'].length;
    },
    is_storage() {
      return this.$store.getters['pricelist/is_storage'];
    },
    info_show() {
      return this.count && this.first;
    }
  },
  watch: {
    count() {
      this.toggle_button_is_storage = this.is_storage;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.vue-js-switch {
  transform: scale(.85);
  @media(min-width: 576px) {
    transform: scale(1);
  }
}
.storage {
  display: block;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  background: rgba(255,255,255,.97);
  padding: 0px 60px;
  z-index: 200;
  border-bottom: 1px solid #DDD;
  font-size: .6em;
  text-align: center;
  @media(min-width: 768px) {
    display: block;
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    background: rgba(255,255,255,.97);
    padding: 0px 60px;
    z-index: 200;
    border-bottom: 1px solid #DDD;
    font-size: .8em;
    text-align: center;
  }
  .info {
    .alert {
      font-size: 1em;
      margin: 15px 0;
      @media(min-width: 576px) {
        font-size: .8em;
      }
    }
  }
  .option {
    a {
      text-decoration: underline;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
      &.active {
        text-decoration: none;
        font-weight: 700;
      }
      &.btn-primary {
        color: #fff;
        text-decoration: none;
      }
    }
  }
  .option-all {
    text-align: center;
    position: relative;
    left: 0px;
    @media(min-width: 576px) {
      text-align: right;
    }
    @media(min-width: 992px) {
      left: 30px;
    }
  }
  .option-storage {
    text-align: center;
    right: 0px;
    @media(min-width: 576px) {
      text-align: left;
    }
    @media(min-width: 992px) {
      right: 30px;
    }
    .btn {
      display: block;
      font-size: .8em;
      @media(min-width: 576px) {
        display: inline;
        font-size: .8em;
      }
    }
  }
  .choose {
    text-align: center;
  }
  .in-modal {
    color: #2c3e50;
    .content {
      padding: 15px 30px;
      .separator {
        select {
          font-size: .8em;
          option {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            padding: 15px 0;
          }
        }
      }
    }
    .header {
      background: #23497f;
      padding: 15px 30px;
      color: #fff;
    }
    .x {
      color: #f15642;
      font-weight: 700;
      cursor: pointer;
    }
    .categories {
      ul {
        padding: 0;
        margin: 0;
        li {
          list-style-type: none;
          padding: 0;
          margin: 0;
          line-height: 1.4em;
        }
      }
    }
    .products {
      line-height: 1.4em;
      .x {
        margin-left: 2px;
      }
      .product {
        margin-right: 4px;
      }
    }

  }
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .35s ease;
}
.slide-fade-leave-active {
  transition: all .35s cubic-bezier(.2, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Storage/Storage.vue